import { render } from "./rightBar2.vue?vue&type=template&id=2ae29ea2"
import script from "./rightBar2.vue?vue&type=script&lang=js"
export * from "./rightBar2.vue?vue&type=script&lang=js"
script.render = render

export default script